<div class="d-flex direction-column p-30">
  <div class="lot__info pb-50">
    <app-detalhes-lotes-card
      [lote]="lot"
      [typeDetail]="typeLot"
      [isDialog]="true" 
    ></app-detalhes-lotes-card>
  </div>
  <div class="lot__contracts">
    <ng-container *ngIf="!lot?.Contracts || lot?.Contracts?.length === 0">
      <div
        class="conteudo-contracts contracts d-flex direction-column row-gap-8"
      >
        <div class="contracts-empty empty">
          <span class="empty-message"> Sem contratos disponíveis </span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngFor="let contract of lot?.Contracts; let i = index">
      <div class="d-flex">
        <app-cards-contratos-lotes
          [contract]="contract"
          [showBeneficiaryName]="true"
          [typeDetail]="typeLot"
          class="vw-100"
        >
        </app-cards-contratos-lotes>
      </div>
    </ng-container>
  </div>
</div>
